exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".widget-empty[data-v-41fce415] {\n  color: #ccc;\n  text-align: center;\n  padding: 50px;\n}", ""]);

// exports
